// Utility read the url for temp dashboard
// parse module name as per used standard

const persistedModule = 'viewer-module';

export const urlTransform = (url: string, module = persistedModule, include= true) => {
  if(url.search(module) < 0) {
    return url;
  }
  if (include === void 0) {
    include = false;
  }
  return url.substring(0, url.indexOf(module) + (include ? module.length : 0));
}
